import EditVehicleModal from './EditVehicleModal';

export default EditVehicleModal;
